import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

async function request(projectId, suffix, body, signal) {
  try {
    const response = await authFetch(`${BACKEND_URL}/project/${encodeURIComponent(projectId)}/${suffix}`, {
      method: body === undefined ? "GET" : "POST",
      ...(body === undefined ? {} : { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }),
      signal,
    });
    const result = await response.json().catch(() => null);
    return result && response.ok ? result : { success: false, message: result?.message || "요청을 처리하지 못했습니다." };
  } catch (error) {
    if (error.name === "AbortError") throw error;
    return { success: false, message: "서버에 연결하지 못했습니다." };
  }
}

export const getProjectNodes = (id, signal) => request(id, "nodes", undefined, signal);
export const getTreeDashboard = (id, nodeId, signal) => request(id, `nodes/${encodeURIComponent(nodeId)}/dashboard`, undefined, signal);
export async function deleteProjectNode(id, nodeId) {
  try {
    const response = await authFetch(`${BACKEND_URL}/project/${encodeURIComponent(id)}/nodes/${encodeURIComponent(nodeId)}`, { method: "DELETE" });
    const result = await response.json().catch(() => null);
    return response.ok && result ? result : { success: false, message: result?.message || "노드를 삭제하지 못했습니다." };
  } catch { return { success: false, message: "서버에 연결하지 못했습니다. 목록을 다시 조회하세요." }; }
}
export const postProjectNodes = (id, paths) => request(id, "nodes", { paths });
export async function postProjectNodeImage(id, nodeId, image) {
  try {
    const form = new FormData();
    form.append("image", image, image.name);
    const response = await authFetch(`${BACKEND_URL}/project/${encodeURIComponent(id)}/nodes/${encodeURIComponent(nodeId)}/image`, {
      method: "POST",
      body: form,
    });
    const result = await response.json().catch(() => null);
    return result && response.ok ? result : { success: false, message: result?.message || "대표이미지를 저장하지 못했습니다." };
  } catch {
    return { success: false, message: "서버에 연결하지 못했습니다." };
  }
}
export const getProjectDeletedFiles = (id, page = 1, signal) => request(id, `deleted-files?page=${page}`, undefined, signal);
export async function deleteProjectNodeImage(id, nodeId, previousImagePath) {
  try {
    const response = await authFetch(`${BACKEND_URL}/project/${encodeURIComponent(id)}/nodes/${encodeURIComponent(nodeId)}/image`, {
      method: "DELETE", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ previous_image_path: previousImagePath }),
    });
    const result = await response.json().catch(() => null);
    return response.ok && result ? result : { success: false, message: result?.message || "대표이미지를 삭제하지 못했습니다." };
  } catch { return { success: false, message: "서버에 연결하지 못했습니다. 목록을 다시 조회하세요." }; }
}
export const postRestoreProjectFiles = (id, ids) => request(id, "files/restore", { ids });
